import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import React from 'react'

const DateTimeField = ({ onChange, value, ...props }) => {
  const parsedValue = value ? dayjs(value) : null

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        value={parsedValue}
        onChange={onChange}
        variant="inline"
        margin="dense"
        size="small"
        ampm={false}
        openTo="day"
        format="DD/MM/YYYY HH:mm:ss"
        slotProps={{
          ...props?.slotProps,
          textField: {
            ...props?.slotProps?.textField,
            fullWidth: true,
            margin: 'dense',
            variant: 'outlined',
            size: 'small',
          },
        }}
        {...props}
      />
    </LocalizationProvider>
  )
}

export default DateTimeField
